"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var BonusTournamentsPrizesEditor_1 = require("./BonusTournamentsPrizesEditor");
var BonusTournamentsPrizesList_1 = require("./BonusTournamentsPrizesList");
var BonusTournamentPrizes = /** @class */ (function (_super) {
    __extends(BonusTournamentPrizes, _super);
    function BonusTournamentPrizes(props) {
        return _super.call(this, props) || this;
    }
    BonusTournamentPrizes.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_AC = this.props.listAppCurrency.Subscribe("*", function (id, data) {
            _this.setState({ availCurrency: data.data });
        });
        this.SID_AB = this.props.listBonusTemplates.Subscribe("*", function (id, data) {
            _this.setState({ availBonuses: data.data });
        });
        this.setState({
            edit_mode: "LIST",
            record: null,
            availCurrency: [],
            availBonuses: []
        }, function () {
            _this.props.listAppCurrency.LoadData();
            _this.props.listBonusTemplates.LoadData(_this.props.record.brand_id);
        });
        this.props.state.setExtBreadCrumbPath(["Турниры", "Суммы турниров"]);
    };
    BonusTournamentPrizes.prototype.componentWillUnmount = function () {
        this.props.listAppCurrency.UnSubscribe(this.SID_AC);
        this.props.listBonusTemplates.UnSubscribe(this.SID_AB);
    };
    BonusTournamentPrizes.prototype.onGoBackToTopPageClick = function () {
        if (this.props.onGoBackClick) {
            this.props.onGoBackClick();
        }
    };
    BonusTournamentPrizes.prototype.onNewClick = function () {
        this.setState({ edit_mode: "NEW", record: null });
    };
    BonusTournamentPrizes.prototype.onEditClick = function (item) {
        this.setState({ edit_mode: "EDIT", record: item });
    };
    BonusTournamentPrizes.prototype.onGoBackClick = function () {
        this.setState({ edit_mode: "LIST", record: null });
    };
    BonusTournamentPrizes.prototype.getBrandCountriesRenderObject = function () {
        if (this.state.edit_mode === "NEW") {
            return (React.createElement(BonusTournamentsPrizesEditor_1.default, { state: this.props.state, data: this.props.dataPrizes, rootRecord: this.props.record, onGoBack: this.onGoBackClick.bind(this), availCurrency: this.state.availCurrency, record: null, availBonuses: this.state.availBonuses, listBonusPrizeType: this.props.listBonusPrizeType }));
        }
        if (this.state.edit_mode === "EDIT") {
            return (React.createElement(BonusTournamentsPrizesEditor_1.default, { state: this.props.state, data: this.props.dataPrizes, rootRecord: this.props.record, onGoBack: this.onGoBackClick.bind(this), availCurrency: this.state.availCurrency, record: this.state.record, availBonuses: this.state.availBonuses, listBonusPrizeType: this.props.listBonusPrizeType }));
        }
        if (this.state.edit_mode === "LIST") {
            return (React.createElement(BonusTournamentsPrizesList_1.default, { state: this.props.state, data: this.props.dataPrizes, rootRecord: this.props.record, onGoBackClick: this.onGoBackToTopPageClick.bind(this), onNewClick: this.onNewClick.bind(this), onEditClick: this.onEditClick.bind(this) }));
        }
    };
    BonusTournamentPrizes.prototype.render = function () {
        return (React.createElement("div", null, this.getBrandCountriesRenderObject()));
    };
    return BonusTournamentPrizes;
}(React.Component));
exports.default = BonusTournamentPrizes;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_tournament/ui/component/options/prizes/BonusTournamentPrizes.tsx
// module id = 2514
// module chunks = 0